import { Button } from 'antd'
import { useState, VFC } from 'react'
import { useTranslation } from 'react-i18next'

import ImportPageHeader from '@/components/pages/ImportPageHeader'
import { ImportWashingMachinePartUploadCvs } from '@/components/pages/WashingMachinePart/Import'

import { useImportWashingMachinePart } from './Import.hooks'

const ImportWashingMachinePart: VFC = () => {
  const { importWashingMachinePart, loading } = useImportWashingMachinePart()

  const [fileName, setFileName] = useState('')
  const [t] = useTranslation()
  const [file, setFile] = useState<File | null>(null)

  const handleFileSelected = (data: FormData) => {
    const file = data.get('file') as File
    setFileName(file.name)
    setFile(file)
  }

  const handleSubmit = () => {
    if (file) {
      const payload = { nameIdx: 0, manufacturerIdx: 1, supplierIdx: 2, priceIdx: 3, inventoryIdx: 4 }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('payload', JSON.stringify(payload))

      importWashingMachinePart(formData)
    }
  }

  return (
    <>
      <ImportPageHeader title={t('pages.washingMachinePart.importFromCsv.title')} />
      <ImportWashingMachinePartUploadCvs loading={loading} onUpload={handleFileSelected} fileName={fileName} />
      <Button disabled={!fileName} type="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
        {t('pages.employees.importFromCsv.submit')}
      </Button>
    </>
  )
}

ImportWashingMachinePart.displayName = 'ImportWashingMachinePart'
export default ImportWashingMachinePart
